import React from 'react';
import {connect} from 'react-redux';
import {I18n} from 'react-redux-i18n';
import {get, find} from 'lodash';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import {defaultLanguage} from '../app/translation';
import {setUserLanguage} from '../app/user/UserActions';
import './LanguageSelection.css';

const langOptions = [
  {
    id: 'pt-br',
    name: 'page.settings.language.portugueseBR'
  },
  {
    id: 'en-us',
    name: 'page.settings.language.englishUS'
  },
  {
    id: 'pl',
    name: 'page.settings.language.polish'
  },
  {
    id: 'nl',
    name: 'page.settings.language.dutch'
  },
  {
    id: 'fr',
    name: 'page.settings.language.french'
  },
  {
    id: 'de',
    name: 'page.settings.language.german'
  },
  {
    id: 'it',
    name: 'page.settings.language.italian'
  },
  {
    id: 'es',
    name: 'page.settings.language.spanish'
  }
];

class LanguageSelection extends React.Component {
  state = {
    open: false,
    currentLang: {}
  };

  componentWillMount() {
    let currentLangId = localStorage.getItem('language');
    if (!currentLangId) {
      currentLangId = navigator.language.toLowerCase();
    }

    let currentLang = find(langOptions, {id: currentLangId});
    if (!currentLang) {
      currentLang = find(langOptions, {id: defaultLanguage});
    }
    this.setState({currentLang});
  }

  handleClickLang = () => {
    this.setState({open: !this.state.open});
  };

  handleSwitchLanguage = lang => () => {
    const userInformation = get(this.props, 'user.userInformation', {});
    this.props.setUserLanguage(userInformation.userId, lang.id);
    this.setState({open: false, currentLang: lang});
  }

  renderLanguageSelector = () => {
    const {currentLang: {id: currentLangId}} = this.state;
    return langOptions.map(e => {
      if (e.id === currentLangId) {
        return null;
      }

      return (
          <ListItem button key={`lang-${e.id}`} className="profile-dropdown__langswitch-item" onClick={this.handleSwitchLanguage(e)}>
            <ListItemText inset primary={I18n.t(e.name)}  className="eachLanguage" />
          </ListItem>
      );
    });
  }

  render() {
    const {currentLang} = this.state;
    return (
        <List component="nav">
          <ListItem button onClick={this.handleClickLang}>
            <ListItemIcon>
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABZUlEQVRIie3UP0ucQRAG8F8kaawkXpBACBJE0MbAWQTyCSTVQbgmtkoqwYiNNtFWoqS0FkMO/ASCXQoLBbt0GrAUbbQIchCLdzXr8t77J6RLHphidmfneWZ2dvmPEjxI/Ams4XHJuS462KhLsIvX+F5yroHneIEfZSQxDoKVYRa/0CwL7KuQrInNCnG5eFiwt4wW+vHEb7WTf4tgC59xFfxtrCYxY4l/gZOqBG1Znz/hEcZxHPYakYgUC1jvlTS+5H58wwy+YC6st3AdyPNsP05YdMkLGMA7vMJpSN4JFfVCUVcKx/QNfgaVe2FtNKeCe+dTti6eyuY8RgMfI+U7sqr2cYSXRapjzOcoSq2LIXzFCJaKKsjDsGzmb206SXDbnik8CyS1CFI0kwTvZSO7iQ8h5rAXQeGN98AgVvAWl7KHePYHee6QVlBm9yqo8tld1BR0HjtVWnQie3TtCvHnWKwp6F/HDbgmZy/55LTBAAAAAElFTkSuQmCC"/>          </ListItemIcon>
            <ListItemText inset primary={I18n.t(currentLang.name)} className="noPadding" />
            {this.state.open ? <Icon>expand_less</Icon> : <Icon>expand_more</Icon>}
          </ListItem>
          <Collapse in={this.state.open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {this.renderLanguageSelector()}
            </List>
          </Collapse>
        </List>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps, {setUserLanguage})(LanguageSelection);
